module.exports = __webpack_public_path__ + "img/Lebenserwartung.fbee79f6.png";